import React from "react";
import { IDialogProps } from "./interfaces/IDialogProps";
import {
  Dialog as MuiDialog,
  DialogContent,
  Divider,
  DialogActions,
  Box,
  DialogTitle,
  Button,
  Typography,
  Theme,
} from "@mui/material";
import { CustomTypography } from "../formsComponents";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { RoleBasedCustomButton } from "../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import { MODULE_IDS } from "../../constants/enums";

export const Dialog: React.FC<IDialogProps> = (props) => {
  const {
    open,
    title,
    subtitle,
    size,
    fullScreen = false,
    hideCloseIcon = false,
    contentWrappedWithForm,
    contentSx,
    actions,
    onClose,
  } = props;

  const generateActions = () => {
    if (actions) {
      return (
        <DialogActions sx={{ marginTop: 0.5 }}>
          {actions.map((action) => {
            return (
              <RoleBasedCustomButton
                variant={action.variant}
                color="primary"
                type={action.type}
                disabled={action.disabled}
                onClick={action.onClick}
                size="large"
                sx={{ marginRight: "5px" }}
                moduleId={MODULE_IDS.PROJECT}
              >
                {action.label}
              </RoleBasedCustomButton>
            );
          })}
        </DialogActions>
      );
    }
  };

  const renderForm = () => {
    const actionsButtons = generateActions();
    if (contentWrappedWithForm) {
      return (
        <form onSubmit={contentWrappedWithForm.onSubmit}>
          <DialogContent sx={{ maxHeight: "70vh" }}>
            {props.children}
          </DialogContent>
          <Divider />
          {actionsButtons}
        </form>
      );
    }
    return (
      <>
        <DialogContent
          sx={{
            maxHeight: "calc(100vh - 200px)", // Adjust based on title and actions height
            overflowY: "auto", // ensure only this part scrolls
            ...contentSx,
          }}
        >
          {props.children}
        </DialogContent>
        <Divider />
        {actionsButtons}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return (
    <MuiDialog
      open={open}
      fullScreen={fullScreen}
      onClose={onClose}
      maxWidth={size}
      fullWidth
      scroll="paper"
      TransitionComponent={fullScreen ? Transition : undefined}
      sx={{
        "& .MuiDialog-paper": {
          overflow: "hidden", // ✅ outer scroll disabled
        },
      }}
    >
      <DialogTitle
        sx={(theme: Theme) => ({
          background: theme.palette.primary.main,
          color: "#fff",
        })}
      >
        <Box display="flex" justifyContent={"space-between"}>
          <Typography variant="h3" fontWeight={"bold"}>
            {title}
          </Typography>
          {!hideCloseIcon && (
            <Box sx={{ cursor: "pointer" }} onClick={onClose}>
              <CloseIcon />
            </Box>
          )}
        </Box>
        <Typography variant="h6" color="white">
          {subtitle}
        </Typography>
      </DialogTitle>
      <Divider />
      {renderForm()}
    </MuiDialog>
  );
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} />;
});
